import { render, staticRenderFns } from "./CercaCellulare.vue?vue&type=template&id=05399bc2&"
import script from "./CercaCellulare.vue?vue&type=script&lang=js&"
export * from "./CercaCellulare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerHourglass,QInput,QTable,QTr,QTh});
